import Proptypes from "prop-types";
import dayjs from "@shared/dayjs";
import { tdpDates } from "../../../../shared/HOCs/withRedux";
import { EXPIRATION_DATE } from "../../../../shared/reduxRoutes/tdpDatesRoutes";
import ModifyDate from "./ModifyDate";

const getExpiredCounter = (date) => {
  const isPositive = Math.sign(dayjs().diff(dayjs(date)));
  let result = "-";
  if (Number.isNaN(isPositive)) {
    result = "-";
  } else if (isPositive === 1) {
    result = "Expired";
  } else {
    result = `${Math.ceil(dayjs(date).diff(dayjs(), "hours") / 24)} Days`;
  }
  return result;
};

const Expiration = ({ expiration = null }) => (
  <div className="tw-flex tw-justify-between tw-items-center tw-gap-[2px] tw-px-[12px] tw-h-[44px] tw-min-h-[44px] tw-rounded tw-bg-tinted-gray-50 tw-text-gray-75 tw-text-[14px] tw-font-semibold tw-leading-[20px]">
    Expiration
    <span className="tw-font-normal">{getExpiredCounter(expiration.date)}</span>
    <ModifyDate date={expiration} />
  </div>
);

Expiration.propTypes = {
  expiration: Proptypes.shape({ id: Proptypes.string, name: Proptypes.string, date: Proptypes.string }),
};

const ExpirationWrapped = tdpDates({
  WrappedComponent: Expiration,
  states: EXPIRATION_DATE,
});

export default ExpirationWrapped;
